import * as React from 'react'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import { useCreateTagForm } from 'modules/ats/lib/utils/useCreateTagForm'

interface Props {
  search: string
}

export const SearchEmptyState = ({ search }: Props) => {
  const { company } = useCurrentSession()
  const { createTagForm: form } = useCreateTagForm({ companyId: company.id })
  const handleSubmit = () => {
    form.setValues({ ...form.values, name: search })
    form.handleSubmit()
  }

  return (
    <Box padding="s32" alignItems="center" gap="s16">
      <Text.Normal>{i18n.t('ats.tags.search.empty_state.description')}</Text.Normal>

      <Button disabled={form.isSubmitting} type="secondary" onClick={handleSubmit} iconName="add">
        {i18n.t('ats.tags.search.empty_state.button', { tagName: search })}
      </Button>
    </Box>
  )
}
